import { IntakeLabelCollection } from '../../entities/intake-label.interface';
import { ProgramList } from '../../constants/program-list';

const diaName = ProgramList.dia;

export const AishAssetsToolTips: IntakeLabelCollection = {
  bankAccounts: {
    label: 'Include all bank account types e.g. chequing, savings, business.',
  },
  insurance: {
    label: 'Cash value of your life insurance.',
    onBehalfLabel: `Cash value of <<oboName>>'s life insurance.`,
  },
  lira: {
    label: `These assets are exempt and do not affect your eligibility for ${diaName.abbreviation} benefits. However, you must report them to help ${diaName.abbreviation} understand your financial situation and determine eligibility.`,
    onBehalfLabel: `These assets are exempt and do not affect <<oboName>>'s eligibility for ${diaName.abbreviation} benefits. However, you must report them to help ${diaName.abbreviation} understand <<oboName>>'s financial situation and determine eligibility.`,
  },
  uncashedChequesOrCashOnHand: {
    label: 'Money or cheques you have in your wallet, house or at another location.',
    onBehalfLabel: `Money or cheques <<oboName>> has in their wallet, house or at another location.`,
  },
};

export const AishAssetsLabels: IntakeLabelCollection = {
  assetTypesIntro: {
    label: 'Fill in only the fields that apply to you, and provide the approximate value.',
    spousePartnerLabel:
      'Fill in only the fields that apply to you and your <<spouseLabel>>. Provide the approximate value. If an asset is shared between you and your <<spouseLabel>>, allocate the full amount to your column.',
    onBehalfLabel: `Fill in only the fields that apply to <<oboName>>, and provide the approximate value.`,
    // onBehalfSpousePartnerLabel: `Fill in only the fields that apply to <<oboName>> and <<spouseName>>. Provide the approximate value. If an asset is shared between <<oboName>> and their <<spouseLabel>>, allocate the full amount to <<oboName>>'s column.`,
    onBehalfSpousePartnerLabel: `Fill in only the fields that apply to <<oboName>> and <<oboSpouseName>>. Provide the approximate value.`,
  },
  applicantAssetsColumn: {
    label: 'Personal',
    onBehalfLabel: `<<oboName>>`,
  },
  spouseAssetsColumn: {
    label: '<<spouseLabelUpper>>',
    onBehalfSpousePartnerLabel: `<<oboSpouseName>>`,
  },
  applicantAssetsDocuments: {
    label: 'Personal asset documents',
    onBehalfLabel: `<<oboName>>'s asset documents`,
  },
  spouseAssetsDocuments: {
    label: '<<spouseLabelUpper>> asset documents',
    onBehalfSpousePartnerLabel: `<<oboSpouseName>>'s asset documents`,
  },
  uploaderDescription: {
    label: 'Based on the information you have provided the following documents are required to assess your application',
    onBehalfLabel: `Based on the information you have provided the following documents are required to assess this application`,
    onBehalfSpousePartnerLabel: `Based on the information you have provided the following documents are required to assess this application`,
  },
  assetType: {
    label: 'Asset type (approximate value)',
  },
  personal: {
    label: 'Personal',
    thirdPersonLabel: '<<applicantName>>',
    onBehalfLabel: '<<oboName>>',
  },
  spouse: {
    label: 'Spouse/Partner',
    thirdPersonLabel: '<<spouseName>>',
    onBehalfSpousePartnerLabel: '<<oboSpouseName>>',
  },
  hasPrimaryAssets: {
    label: 'You have not shared any asset information. Do you have any of the above assets?',
    // replacementLabel:
    //   'You have not shared any asset information. Do you or your <<replacementLabel>> have any of the above assets?',
    spousePartnerLabel:
      'You have not shared any asset information. Do you or your <<spouseLabel>> have any of the above assets?',
    onBehalfLabel: `You have not shared any asset information. Does <<oboName>> have any of the above assets?`,
    onBehalfSpousePartnerLabel:
      'You have not shared any asset information. Does <<oboName>> and <<oboSpouseName>> have any of the above assets?',
  },
};
